import moment from 'moment-timezone';

/**
 * @param date YYYY-MM-DD
 * @param time hh:mm
 * @returns {string}
 */
const setTime = (date, time) =>
  moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').format();

export default setTime;
